import { render, staticRenderFns } from "./postImages.vue?vue&type=template&id=549c8646&lang=pug&"
import script from "./postImages.vue?vue&type=script&lang=js&"
export * from "./postImages.vue?vue&type=script&lang=js&"
import style0 from "./postImages.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "postImages.vue"
export default component.exports